/**
 * @tabler/icons-react v2.47.0 - MIT
 */

import createReactComponent from '../createReactComponent.js';

var IconLetterKSmall = createReactComponent("letter-k-small", "IconLetterKSmall", [
  ["path", { d: "M10.5 8v8", key: "svg-0" }],
  ["path", { d: "M14.5 8l-3 4l3 4", key: "svg-1" }],
  ["path", { d: "M10.5 12h1", key: "svg-2" }]
]);

export { IconLetterKSmall as default };
//# sourceMappingURL=IconLetterKSmall.js.map
